import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import CircularProgress from 'material-ui/Progress/CircularProgress'
import green from 'material-ui/colors/green'
import Input from 'material-ui/Input'
import { SelectWrapped, style as selectStyle } from '../common/SelectWrapped'

const style = theme => ({
  root: {
    flexDirection: 'column'
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '20px',
    left: '60px',
    marginTop: -12,
    marginLeft: -12
  },

  ...selectStyle(theme)
})

class JobsForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      multi: props.stops
    }
    this.handleChangeMulti = this.handleChangeMulti.bind(this)
  }

  handleChangeMulti (multi) {
    this.setState({
      multi
    })
    this.props.onFormChange('stops', multi.map(value => value.value))
  }

  render () {
    const {
      classes,
      title,
      stops,
      onFormChange,
      onJobSave,
      successMsg,
      isJobsRequestOngoing,
      locations
    } = this.props

    const { multi } = this.state

    return (
      <div>
        <form noValidate autoComplete='off' className={classes.root}>
          <TextField
            id='title'
            label='Title'
            margin='normal'
            fullWidth
            value={title}
            onChange={e => onFormChange('title', e.target.value)}
          />

          <Input
            fullWidth
            inputComponent={SelectWrapped}
            inputProps={{
              classes,
              value: multi,
              multi: true,
              onChange: this.handleChangeMulti,
              placeholder: 'Search through locations, can select multiple',
              instanceId: 'react-select-chip',
              id: 'react-select-chip',
              name: 'react-select-chip',
              simpleValue: false,
              options: locations.map(location => ({
                value: location,
                label: location.name
              }))
            }}
          />

          <div className={classes.wrapper}>
            <Button
              disabled={title === '' || !stops || isJobsRequestOngoing}
              color='primary'
              variant='raised'
              onClick={onJobSave}
            >
              Create Job
            </Button>
            &nbsp;
            {isJobsRequestOngoing && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
            {!isJobsRequestOngoing && successMsg}
          </div>
        </form>
      </div>
    )
  }
}

JobsForm.defaultProps = {
  title: '',
  stops: null
}

export default withStyles(style)(JobsForm)



// WEBPACK FOOTER //
// ./src/jobs/JobsForm.js